export const WORKFLOW_TABLE = "workflows"
export const WORKFLOW_TABLE_SCHEMA =
  "id, companyId, userId, scope, isActive, syncId"
